import { ChevronRight } from '@mui/icons-material';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { Card, Chip, Row, Stack, Text } from 'library/ui';
import React from 'react';
import { useHistory } from 'react-router';
import { ApplicantApprovalSummary } from './BusinessCalendar';

export default function UnfilledShiftsWithApprovals({
    approvalsForJob,
    jobId,
    count,
    onViewShifts,
}: {
    approvalsForJob?: ApplicantApprovalSummary;
    jobId: string;
    count: number;
    onViewShifts: () => void;
}) {
    const history = useHistory();
    const newApprovalsCount = approvalsForJob?.applicants.filter((a) => !a.viewed).length || 0;
    const awaitingConfirmationCount = (approvalsForJob?.applicants.length || 0) - newApprovalsCount;
    return (
        <Stack key={jobId} gap="none">
            <UnfilledCard onClick={onViewShifts} interactive padding="xs" tone="error">
                {count} unfilled shift{count === 1 ? '' : 's'}
            </UnfilledCard>
            <ApprovalsButton
                onClick={() => history.push(`jobs/${jobId}/applicants`)}
                interactive
                padding="xs"
                $highlighted={newApprovalsCount > 0}
                tone="error"
            >
                <Row justify="between" align="center" gap="sm" fullWidth>
                    <Row gap="sm" wrap align="center">
                        {newApprovalsCount > 0 && (
                            <>
                                <Text tone="overlay" weight="bold">
                                    To review ({newApprovalsCount})
                                </Text>
                                <Chip variant="filled" bgColor={Colors.white} textColor={Colors.darkNavy}>
                                    New!
                                </Chip>
                                <Text tone="overlay" size="sm">
                                    Interested near-match workers available
                                </Text>
                            </>
                        )}
                        {awaitingConfirmationCount > 0 && (
                            <Text size="sm" tone={newApprovalsCount ? 'overlay' : 'primary'}>
                                Approvals pending acceptance ({awaitingConfirmationCount})
                            </Text>
                        )}
                    </Row>
                    <ChevronRight htmlColor={newApprovalsCount ? Colors.white : Colors.darkNavy} fontSize="large" />
                </Row>
            </ApprovalsButton>
        </Stack>
    );
}

const UnfilledCard = styled(Card)({
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderBottom: 'none',
});

const ApprovalsButton = styled(Card)<{ $highlighted: boolean }>(({ $highlighted }) => ({
    backgroundColor: $highlighted ? Colors.error : Colors.errorBackground,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    textAlign: 'left' as const,
}));
